<template>
    <div class="smsManage">
        <el-tabs tab-position="top">
            <el-tab-pane label="常规短信">
                <sms-send></sms-send>
            </el-tab-pane>
            <el-tab-pane label="回访短信">
                <sms-return-visit></sms-return-visit>
            </el-tab-pane>
            <el-tab-pane label="短信模版">
                <sms-template></sms-template>
            </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
import { findMemberList } from "@/api/index";
import SmsSend from "./SmsSend.vue";
import SmsReturnVisit from "./SmsReturnVisit.vue";
import SmsTemplate from "./SmsTemplate.vue";

export default {
    components: {
        SmsSend,
        SmsReturnVisit,
        SmsTemplate
    },
     data() {
        return {
          
        };
    },
    methods: {
        
    }
};
</script>

<style lang="scss">
.smsManage {
    background-color: #FFFFFF;
    padding: 16px;
    margin: 20px;
    border-radius: 10px;
    // -webkit-box-shadow:0px 3px 3px #c8c8c8;
    // -moz-box-shadow:0px 3px 3px #c8c8c8;
    box-shadow:0px 3px 3px #c8c8c8;
}
</style>